<template>
  <div id="NfeAttachments">
    <v-dialog v-model="open" persistent max-width="700">
      <v-card class="align-center text-center">
        <v-card-text>
          <div class="pt-5 d-flex align-center justify-space-between">
            <h1>Anexos</h1>
            <v-btn icon @click="close()" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
          <div class="mt30"></div>
          <v-row justify="center">
            <v-col cols="12">
              <v-card
                justify="flex-start"
                v-for="(attachment, id) in nfeAttachments"
                :key="attachment.fileName + id"
                class="mb-2"
              >
                <v-card-text v-if="!loading" class="text-left justify-space-between d-flex">
                  <div>
                    <v-icon> mdi-file </v-icon>
                    {{ attachment.fileName }}
                  </div>
                  <div>
                    <span role="button" @click="removeNfeAttachmentById(attachment.id)" target="_blank" class="mr-3"
                      ><v-icon> mdi-delete </v-icon>
                    </span>
                    <span role="button" @click="downloadNfeById(attachment.id, attachment)" target="_blank"
                      ><v-icon> mdi-download </v-icon>
                    </span>
                  </div>
                </v-card-text>
              </v-card>
              <v-card-text class="d-flex flex-column align-center" v-if="loading">
                <span class="pb-2">Carregando Anexos...</span>
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </v-card-text>
              <div class="mt30"></div>
              <div class="area-drop" :class="{ ativo: images.length }">
                <div class="message-drop">
                  <v-icon> mdi-folder-multiple-image </v-icon>
                  <p>
                    {{ images.length ? 'Arquivo selecionado' : 'Selecione ou arraste um arquivo aqui.' }}
                  </p>
                </div>
                <input v-if="!uploadLoading && open" required type="file" @change="(e) => uploadImageSuccess(e)" />
              </div>
            </v-col>
          </v-row>

          <div class="mt10"></div>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-btn color="error" class="flex-grow-1" large @click="close(false, null)"> Cancelar </v-btn>
          <v-btn
            :loading="uploadLoading"
            :disabled="images.length === 0"
            color="success"
            class="flex-grow-1"
            large
            @click="uploadImagesNfe()"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import download from 'downloadjs';

export default {
  name: 'NfeAttachments',
  props: {
    open: {
      default: false,
      type: Boolean
    },
    nfeId: {
      default: null,
      type: String
    }
  },
  data: () => ({
    nfeAttachments: [],
    images: [],
    imagesToUpload: [],
    message: [],
    loading: false,
    uploadLoading: false
  }),
  watch: {
    open: {
      handler(isOpen) {
        if (isOpen) {
          this.nfeAttachments = [];
          this.images = [];
          this.imagesToUpload = [];
          this.fetchAllNfeAttachmentsById(this.nfeId);
        }
      }
    }
  },
  methods: {
    ...mapActions('NfeStore', [
      'createNfeAttachments',
      'deleteNfeAttachmentById',
      'fetchNfeAttachmentsById',
      'fetchDownloadNfeAttachmentsById'
    ]),
    async fetchAllNfeAttachmentsById(id) {
      this.loading = true;
      try {
        this.nfeAttachments = await this.fetchNfeAttachmentsById(id);
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async removeNfeAttachmentById(id) {
      try {
        await this.deleteNfeAttachmentById(id);

        this.message = {
          errors: ['Arquivo deletado com sucesso!'],
          errorsType: 'success'
        };
      } catch (e) {
        console.error(e);
        this.message = {
          errors: ['Opss, algo deu errado!'],
          errorsType: 'error',
          error500: e
        };
      } finally {
        this.fetchAllNfeAttachmentsById(this.nfeId);
        this.$emit('actionsMessage', this.message);
      }
    },
    async downloadNfeById(id, file) {
      try {
        const data = await this.fetchDownloadNfeAttachmentsById(id);

        download(data, file.fileName);
        this.message = {
          errors: ['Seu dowload está sendo iniciado!'],
          errorsType: 'success'
        };
      } catch (e) {
        console.error(e);
        this.message = {
          errors: ['Opss, algo deu errado!'],
          errorsType: 'error',
          error500: e
        };
      } finally {
        this.$emit('actionsMessage', this.message);
      }
    },
    async uploadImagesNfe() {
      this.uploadLoading = true;
      const params = {
        id: this.nfeId,
        body: this.imagesToUpload
      };
      try {
        const data = await this.createNfeAttachments(params);
        if (data.success) {
          this.message = {
            errors: ['Upload realizado com sucesso!'],
            errorsType: 'success'
          };
        }
      } catch (e) {
        console.error(e);
        this.message = {
          errors: ['Opss, algo deu errado!'],
          errorsType: 'error',
          error500: e
        };
      } finally {
        this.$emit('actionsMessage', this.message);
        this.fetchAllNfeAttachmentsById(this.nfeId);
        this.images = [];
        this.imagesToUpload = [];
        this.uploadLoading = false;
      }
    },
    uploadImageSuccess(image) {
      this.images = image.target.files;
      const formData = new FormData();

      formData.append('file', image.target.files[0]);

      this.imagesToUpload = formData;
    },
    actionsMessage(message) {
      this.$emit('nfeAttachmentsActions', message);
    },
    close(hasChange, message) {
      this.$emit('closeNfeAttachments', hasChange, message);
    }
  }
};
</script>

<style lang="scss" scoped></style>
